import React, { useEffect, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import TitleComp from "../Component/TitleComp";
import { Col, Form, FormGroup } from "react-bootstrap";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { Base_Url } from "../BaseUrl";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Bars } from "react-loader-spinner";
import { compressImage } from "../Component/CompressImage";

function Plans() {
  const { id } = useParams();
  const [name, setname] = useState("");
  const [code, setcode] = useState("");
  const [planlistdata, setplanlistdata] = useState([]);
  const [description, setdescription] = useState("");
  const [totalprice, settotalprice] = useState("");
  const [gst_price, setgst_price] = useState("");
  const [monthlyprice, setmonthlyprice] = useState("");
  const [type, settype] = useState("");
  const [cuts, setcuts] = useState("");
  const [cutsdefine, setcutsdefine] = useState(false);
  const [typedefine, settypedefine] = useState(false);
  const [validity, setvalidity] = useState("");
  const [duration, setduration] = useState("");
  const [file, setfile] = useState("");
  const [bulkedit, setbulkedit] = useState(false);
  const [plan, setplan] = useState([]);
  const [editimg, seteditimag] = useState("");
  const [loading, setloading] = useState(false);

  const location = useLocation();

  const planslist = location.pathname == `/planning/${id}`;

  let token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const handleplansget = () => {
    axios.get(`${Base_Url}/plans`, { headers }).then((res) => {
      setplan(res.data.data);
    });
  };

  const handleplanid = (e) => {
    axios.get(`${Base_Url}/plans`, { headers }).then((res) => {
      setplanlistdata(res.data.data[id]);
      // console.log("planid", res.data.data[id]);
      setname(res.data.data[id].name);
      setcode(res.data.data[id].code);
      seteditimag(res.data.data[id].image);
      setdescription(res.data.data[id].description);
      settotalprice(res.data.data[id].total_price);
      setgst_price(res.data.data[id].gst_price);
      setmonthlyprice(res.data.data[id].monthly_price);
      settype(res.data.data[id].type);
      if (res.data.data[id].type == "1") {
        settypedefine(true);
        setbulkedit(true);
      } else {
        settypedefine(false);
        setbulkedit(false);
      }
      if (res.data.data[id].cuts_provided == "1") {
        setcutsdefine(true);
      } else {
        setcutsdefine(false);
      }
      setvalidity(res.data.data[id]?.validity);
      setduration(res.data.data[id]?.duration);
      setcuts(res.data.data[id].cuts_provided);
    });
  };

  useEffect(() => {
    handleplansget();
    if (id) {
      handleplanid();
    }
  }, []);

  const handlecuts = (e) => {
    if (e) {
      if (e.target.value == "1") {
        setcutsdefine(true);
      } else {
        setcutsdefine(false);
      }
      setcuts(e.target.value);
    }
  };

  useEffect(() => {
    if (cuts) {
      handlecuts();
    }
  }, [cuts, id]);

  const handletype = (e) => {
    if (e) {
      if (e.target.value == "1") {
        settypedefine(true);
        setbulkedit(true);
      } else {
        settypedefine(false);
        setbulkedit(false);
      }
      settype(e.target.value);
    }
  };

  useEffect(() => {
    if (type) {
      handletype();
    }
  }, [type, bulkedit]);

  const handlefile = (e) => {
    let selectedfile = e.target.files[0];
    setfile(selectedfile);
  };

  const getRowId = (row) => row._id;
  const navigate = useNavigate();

  // const handleSubmit = (e) => {
  //   setloading(true);
  //   e.preventDefault();
  //   let formdata = new FormData();
  //   formdata.append("name", name);

  //   formdata.append("code", code);

  //   formdata.append("description", description);
  //   formdata.append("total_price", totalprice);
  //   formdata.append("gst_price", gst_price);
  //   formdata.append("monthly_price", monthlyprice);
  //   if (type == "1") {
  //     formdata.append("type", type);
  //     formdata.append("cuts_provided", 0);
  //   } else {
  //     formdata.append("type", type);
  //     formdata.append("cuts_provided", cuts);
  //   }
  //   if (file) {
  //     formdata.append("image", file);
  //   }
  //   if (bulkedit) {
  //     formdata.append("validity", validity);
  //     formdata.append("duration", duration);
  //   }

  //   if (planslist) {
  //     formdata.append("_id", planlistdata._id);
  //     axios.put(`${Base_Url}/plans`, formdata, { headers }).then((res) => {
  //       // console.log(res.data.data);
  //       if (res.data != null) {
  //         setloading(false);
  //         navigate(`/planslist`);
  //       }
  //     });
  //   } else {
  //     axios.post(`${Base_Url}/plans`, formdata, { headers }).then((res) => {
  //       // console.log(res.data.data);
  //       if (res.data != null) {
  //         setloading(false);
  //         navigate(`/planslist`);
  //       }
  //     });
  //   }
  // };


  const handleSubmit = (e) => {
    setloading(true);
    e.preventDefault();
    let formdata = new FormData();
    formdata.append("name", name);
    formdata.append("code", code);
    formdata.append("description", description);
    formdata.append("total_price", totalprice);
    formdata.append("gst_price", gst_price);
    formdata.append("monthly_price", monthlyprice);
    if (type == "1") {
      formdata.append("type", type);
      formdata.append("cuts_provided", 0);
    } else {
      formdata.append("type", type);
      formdata.append("cuts_provided", cuts);
    }
    if (file) {
      compressImage(file).then((compressedFile) => {
        formdata.append("image", compressedFile);
        if (bulkedit) {
          formdata.append("validity", validity);
          formdata.append("duration", duration);
        }
        if (planslist) {
          formdata.append("_id", planlistdata._id);
          axios.put(`${Base_Url}/plans`, formdata, { headers }).then((res) => {
            if (res.data != null) {
              setloading(false);
              navigate(`/planslist`);
            }
          });
        } else {
          axios.post(`${Base_Url}/plans`, formdata, { headers }).then((res) => {
            if (res.data != null) {
              setloading(false);
              navigate(`/planslist`);
            }
          });
        }
      });
    }
  };


  return (
    <>
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}
      <Sidebaar
        content={
          <>
            <TitleComp title="Plans" />
            <Form onSubmit={(e) => handleSubmit(e)}>
              <div className="row gy-3">
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setname(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                {planslist && (
                  <Col md="1">
                    <img
                      src={`${Base_Url}/${editimg}`}
                      className="img-fluid"
                      alt=""
                    />
                  </Col>
                )}
                <Col md={planslist ? "3" : "4"}>
                  <FormGroup>
                    <label htmlFor="">Image</label>
                    <input
                      type="file"
                      onChange={(e) => handlefile(e)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Code</label>
                    <input
                      type="text"
                      value={code}
                      onChange={(e) => setcode(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Total Price</label>
                    <input
                      type="text"
                      value={totalprice}
                      onChange={(e) => settotalprice(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Gst Price</label>
                    <input
                      type="text"
                      value={gst_price}
                      onChange={(e) => setgst_price(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Monthly Price</label>
                    <input
                      type="text"
                      value={monthlyprice}
                      onChange={(e) => setmonthlyprice(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Type</label>
                    <select
                      name=""
                      value={type}
                      onChange={(e) => handletype(e)}
                      id=""
                      className="form-control form-select"
                    >
                      <option value="">Select Type</option>
                      <option value="0">Basic Plan</option>
                      <option value="1">Bulk Edit</option>
                    </select>
                  </FormGroup>
                </Col>
                {typedefine && (
                  <>
                    <Col md="4">
                      <FormGroup>
                        <label htmlFor="">Validity (Days)</label>
                        <input
                          type="text"
                          value={validity}
                          onChange={(e) => setvalidity(e.target.value)}
                          className="form-control"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <label htmlFor="">Duration (Hours)</label>
                        <input
                          type="text"
                          value={duration}
                          onChange={(e) => setduration(e.target.value)}
                          className="form-control"
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
                {!bulkedit && (
                  <Col md="4">
                    <FormGroup>
                      <label htmlFor="">Cuts Provided</label>
                      <select
                        name=""
                        value={cuts}
                        onChange={(e) => handlecuts(e)}
                        id=""
                        className="form-control form-select"
                      >
                        <option value="">Select Type</option>
                        <option value="0">Unlimited</option>
                        <option value="1">Limit</option>
                      </select>
                    </FormGroup>
                  </Col>
                )}
                {cutsdefine && (
                  <Col md="4">
                    <FormGroup>
                      <label htmlFor="">Cut off Limited</label>
                      <input
                        type="text"
                        value={cuts}
                        onChange={(e) => setcuts(e.target.value)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                )}
                <Col md="12">
                  <FormGroup>
                    <label htmlFor="">Description</label>
                    {/* <textarea
                      name=""
                      id=""
                      className="w-100 form-control"
                      rows="5"
                      value={description}
                      onChange={(e) => setdescription(e.target.value)}
                    ></textarea> */}
                    <CKEditor
                      editor={ClassicEditor}
                      data={description}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setdescription(data); // Update this line
                      }}
                      className="custom-ckeditor"
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <button className="btn bg-dark text-white">
                    {planslist ? "Update" : "Submit"}
                  </button>
                </Col>
              </div>
            </Form>
            {/* <Col md="12">
              <Box sx={{ height: 500, width: "100%" }}>
                <DataGrid
                  //   rows={data} // Update this line
                  rows={plan.map((row, index) => ({
                    ...row,
                    index,
                  }))}
                  columns={columns}
                  pageSize={5}
                  getRowId={getRowId}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                />
              </Box>
            </Col> */}
          </>
        }
      />
    </>
  );
}

export default Plans;
